import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GroupWorkIcon(props: IconProps) {
    return <Icon {...props} iconKey={"group_work"}/>
}
